import { useMemo } from "react";
import { TFormStructure } from "formifex";
import { UseFormControllerReturn } from "formifex/dist/components/FormController";
import useRequiredFields from "./useRequiredFields";
import {
	ReportTab,
	buildFieldToTabMap,
	getTabForFieldPath,
} from "../constants/reportTabs";

const INITIAL_COUNTS: Record<string, number> = {};

function useReportTabCounts(
	form: UseFormControllerReturn | undefined,
	reportType: string,
	tabsConfig: ReportTab[]
): Record<string, number> {
	const { unfilledFields } = useRequiredFields(form, reportType);
	const schema = form?.schema as TFormStructure | undefined;

	return useMemo(() => {
		if (!schema?.items || !unfilledFields?.length || !tabsConfig.length) {
			return INITIAL_COUNTS;
		}

		const fieldToTabMap = buildFieldToTabMap(schema.items);
		const counts: Record<string, number> = {};
		for (const tab of tabsConfig) {
			counts[tab.key] = 0;
		}

		for (const fieldPath of unfilledFields) {
			const tab = getTabForFieldPath(fieldPath, tabsConfig, fieldToTabMap);
			if (tab) {
				counts[tab] = (counts[tab] || 0) + 1;
			}
		}

		return counts;
	}, [schema, unfilledFields, tabsConfig]);
}

export default useReportTabCounts;
